import {normalizeRemoteSensingSource} from './remoteSensingModel'

const encodePart = (value) => encodeURIComponent(value == null ? '' : String(value))

export const buildRemoteSensingCacheKey = ({
  accessId = '',
  companyPeriodId = '',
  algorithmVersion = '',
  date = '',
  enhanced = false,
  geometryHash = '',
  landId = '',
  sceneId = '',
  source,
}) => {
  const normalizedSource = normalizeRemoteSensingSource(source)

  return [
    landId,
    geometryHash,
    normalizedSource.provider,
    normalizedSource.product,
    normalizedSource.quality,
    normalizedSource.layer,
    date,
    sceneId,
    enhanced ? 'enhanced' : 'normal',
    algorithmVersion,
    ...(accessId || companyPeriodId ? [accessId, companyPeriodId] : []),
  ].map(encodePart).join(':')
}

export const buildRemoteSensingDatesCacheKey = ({
  accessId = '',
  companyPeriodId = '',
  cloudCoverage = '',
  cloudCoverageFilter = '',
  dateFrom = '',
  dateTo = '',
  geometryHash = '',
  landId = '',
  source,
}) => {
  const normalizedSource = normalizeRemoteSensingSource(source)

  return [
    landId,
    geometryHash,
    normalizedSource.provider,
    normalizedSource.product,
    normalizedSource.quality,
    normalizedSource.layer,
    dateFrom,
    dateTo,
    cloudCoverageFilter,
    cloudCoverage,
    ...(accessId || companyPeriodId ? [accessId, companyPeriodId] : []),
  ].map(encodePart).join(':')
}
